import { MediaAssetsRegistry, getModelsWithMediaAssetsMetadata } from '@common/media/shared';
import { DevToolsRegistry } from '@core/frontend-shared';
import { arraySplitByCondition } from '@core/shared/utils';
import { ClassTransformService, ModelHelper, isEditorModel } from '@core/shared/model';
import { TransformationType } from 'class-transformer-global-storage';
import * as i0 from "@angular/core";
import * as i1 from "@core/frontend-shared";
export let MediaAssetsFrontendRegistry = /*#__PURE__*/(() => {
  class MediaAssetsFrontendRegistry extends MediaAssetsRegistry {
    constructor(debug) {
      super();
      debug.exposeDebugFunction(['MediaAssets', 'Inspect Models'], () => {
        const metaStorage = ClassTransformService.getMetadataStorage();
        const allMediaParentModels = getModelsWithMediaAssetsMetadata();
        const data = allMediaParentModels.map((info, index) => {
          const resolvedModelClassName = ModelHelper.getBaseModelName(info.modelCtor);
          const mediaPropType = metaStorage.findTypeMetadata(info.modelCtor, 'media');
          const foundMediaPropertyType = mediaPropType?.typeFunction() || null;
          const assetsMapModel = this.getMediaAssetMapModelFor(info.modelCtor);
          const foundMediaPropertyType_exposedProps = metaStorage.getExposedProperties(foundMediaPropertyType, TransformationType.PLAIN_TO_CLASS);
          return {
            parent: info.modelCtor,
            resolvedModelClassName,
            assetsMapModel,
            foundMediaPropertyType,
            foundMediaPropertyType_exposedProps
          };
        });
        const [editorModels, rootModels] = arraySplitByCondition(data, entry => {
          return isEditorModel(entry.parent);
        });
        return {
          rootModels,
          editorModels
        };
      });
    }
    ngOnDestroy() {
      this.destroy$.next(true);
    }
    static {
      this.ɵfac = function MediaAssetsFrontendRegistry_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MediaAssetsFrontendRegistry)(i0.ɵɵinject(i1.DevToolsRegistry));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: MediaAssetsFrontendRegistry,
        factory: MediaAssetsFrontendRegistry.ɵfac
      });
    }
  }
  return MediaAssetsFrontendRegistry;
})();